import { toast } from "react-toastify";
import { _single, _UBLInvoice, _UBLItemInvoice, _UBLTaxWithHoldingTax } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable";
import { useEffect, useState } from "react";
import { Modal } from "../../../../../../theme/Component/Modal";
import { Alert } from "../../../../../../theme/Component/Alert";
import { TaxSchemeSimulator } from "../../../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxSchemeSimulator";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { TaxHoldValueListByIDUBLTaxWithHoldingTax } from "./TaxHoldValueListByIDUBLTaxWithHoldingTax";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";

interface Props {
    idublInvoice: number;
    issueDate: any;
    updateLista?: Function;
}

export const UBLInvoiceTaxSupplier = ({ idublInvoice, issueDate, updateLista }: Props) => {

    const _ublTax = useDataBean(_UBLTaxWithHoldingTax);
    const { instance, setBean, bean, lista, setLista } = _ublTax;
    const items = useDataBean(_UBLItemInvoice);
    const { instance: instanceUBL, bean: beanUBL, setBean: setBeanUBL } = useDataBean(_UBLInvoice);
    const modalDelete = useModal("Confirmación", MODAL_SM);
    const modalEdit = useModal("Edición", MODAL_md);
    const modalBase = useModal("Edición", MODAL_SM);

    const [listTax, setListTax] = useState<any>([]);
    const [pending, setPending] = useState<any>([]);
    const [head, setHead] = useState(
        [
            { title: 'ID', property: 'IDTaxSchemeValue', visible: true, mask: MASK_NUMBER },
            { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },
            { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
            { title: 'Fuente Presupuestal', property: 'BudgetSourceName', visible: true },
            { title: 'Obligación', property: 'OBEntity', visible: true },
            { title: 'Impuesto', property: 'TaxCategoryName', visible: true },
            { title: 'TaxCategoryPercent', property: 'TaxCategoryPercent', visible: true },
            { title: 'Unidades', property: 'TaxUnitsTypeName', visible: true },
            { title: 'Base de Impuesto', property: 'TaxableAmount', visible: true },
            { title: 'Valor Retención', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        ]
    )

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRetenciones, setModalRetenciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (idublInvoice && issueDate) {
            instanceUBL.getUblInvoice(idublInvoice, issueDate).then(
                (resp) => {
                    setBeanUBL(resp)
                    getListaItems(resp.IDUBLInvoice, resp.IssueDate);
                    getLista(resp.IDUBLInvoice, resp.IssueDate);

                    if (resp.PaymentType === 18) {
                        setHead([
                            { title: 'ID', property: 'IDTaxSchemeValue', visible: true, mask: MASK_NUMBER },
                            { title: 'Impuesto', property: 'TaxCategoryName', visible: true },
                            { title: 'TaxCategoryPercent', property: 'TaxCategoryPercent', visible: true },
                            { title: 'Unidades', property: 'TaxUnitsTypeName', visible: true },
                            { title: 'Base de Impuesto', property: 'TaxableAmount', visible: true },
                            { title: 'Valor Retención', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
                        ])
                    }

                }
            ).catch(err => { toast.error(err) })
        }

    }, [idublInvoice])

    const getLista = (id: number, issueDate: any) => {
        instance.getUBLTaxWithHoldingTaxTaxCatalog(id, issueDate, 0).then(
            (resp: any) => {
                resp.forEach((element: any) => {
                    element.DataBeanProperties.OBEntity = `${element.DataBeanProperties.OBIDDocument ? `${element.DataBeanProperties.OBMnemonic} - ${element.DataBeanProperties.OBConsecutive}` : ``}`;
                });
                setLista(resp);
            }
        ).catch(err => toast.error(err));
    }

    const getListaItems = (id: number, issueDate: any) => {
        items.instance.getUBLItemInvoiceCatalog(id, issueDate).then(
            (resp) => {
                let tmp = resp;
                tmp.forEach((element: any) => {
                    element.DataBeanProperties.BudgetName = element.DataBeanProperties.BudgetJsconCode + " " + element.DataBeanProperties.BudgetName;
                });
                items.setLista(tmp)
            }
        )
    }

    const updateUBLTaxWithHoldingTaxForUBLInvoice=()=>{
        items.instance.updateUBLTaxWithHoldingTaxForUBLInvoice(idublInvoice,issueDate).then(
            (resp:any)=>{
                getLista(idublInvoice,issueDate);
                toast.success("Valores actualizados");

            }
        )
    }



    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: () => { addTax() } },
        { nombre: 'Actualizar Calculos', visible: true, icono: 'ri-refresh-line', evento: () => { updateUBLTaxWithHoldingTaxForUBLInvoice() } }
    ]

    const addTax = () => {

        if (items.lista.length === 0) {
            toast.error("Debe existir al menos un ítem en la factura para agregar impuestos.");
            return;
        }

        setBean({});
        let pending = [];
        items.lista.forEach(element => {
            if (
                (element.DataBeanProperties.AccountantID == undefined || element.DataBeanProperties.AccountantID == null)
                || (haveCostingCenter(element.DataBeanProperties))
            ) {
                pending.push(element.DataBeanProperties);
            }
        });
        setPending(pending);
        setModal({ ...modal, "view": true, "name": "Agregar Impuestos" });
    };

    const haveCostingCenter = (element: any) => {
        let have = false;
        if (element.RequiresCostingCenter) {
            if (!element.CostingCenterMethod) {
                have = false;
            }
            else if (element.CostingCenterMethod === 2) {
                if (element.CostingCenter)
                    have = true;
            }
            else if (element.CostingCenterMethod === 3) {
                if (element.IDCostingCenterMethod > 0)
                    have = true;
            }
            else if (element.CostingCenterMethod === 4) {
                have = true;
            }
        } else {
            have = true;
        }
        return !have;
    }

    const parseTaxSchemaValuesWithHoldingTaxForUBLInvoice = () => {
        if (listTax.length > 0) {
            let tax = [];
            let cero = 0;

            listTax.forEach(element => {
                if (element.DataBeanProperties.TaxBase == undefined)
                    cero++;

                tax.push({
                    DataBeanProperties: { ...element.DataBeanProperties },
                    DataBeanName: "com.quickdataerp.bean.admin.TaxSchemeValue"
                });
            });

            if (cero === 0) {
                instanceUBL.parseTaxSchemaValuesWithHoldingTaxForUBLInvoice3(idublInvoice, issueDate, tax).then(
                    (resp) => {
                        console.log(resp)
                        setModal({ ...modal, view: false });
                        getLista(beanUBL.IDUBLInvoice, beanUBL.IssueDate);
                    }
                ).catch(
                    err => {
                        console.log(err)
                    }
                )
            } else {
                toast.error("No ha definido un valor base para cada impuesto");
            }
        } else {
            toast.error("No ha seleccionado ningún impuesto");
        }
    };

    const listaBotonesImpuesto = () => {
        const botones = [
            { titulo: 'Editar Impuesto', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => modalEdit.open() },
            { titulo: 'Editar Base', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => modalBase.open() },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canEdit(), evento: () => modalDelete.open() },
            { titulo: 'Ver Calculo de retención como Empleado', icono: 'ri-file-list-line', visible: true, evento: () => { setModalRetenciones({ ...modalRetenciones, view: true, name: "Ver Calculo de retención como Empleado" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteTaxSchemeWithHoldingTaxForUBLInvoice = () => {

        instanceUBL.deleteTaxSchemeWithHoldingTaxForUBLInvoice(idublInvoice, issueDate, bean.IDTaxSchemeValue).then(
            (resp: any) => {
                getLista(beanUBL.IDUBLInvoice, beanUBL.IssueDate);
                modalDelete.close();
            }
        ).catch(err => console.error(err));

    }

    const updateUBLTaxWithHoldingTax = () => {
        instanceUBL.updateUBLTaxWithHoldingTax(bean).then(
            (resp: any) => {
                getLista(beanUBL.IDUBLInvoice, beanUBL.IssueDate);
                modalEdit.close();
            }
        ).catch(err => console.error(err));

    }
    const updateUblTax=()=>{
        _ublTax.updateCustonBean(bean).then(
            (resp:any)=>{
                modalBase.close();
                updateUBLTaxWithHoldingTaxForUBLInvoice() ;
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <strong>Proveedor </strong><small>{beanUBL.AccountSupplierName}</small>
            </div>
            <div className="col-md-6">
                <strong>Idenficación </strong><small>{beanUBL.AccountSupplierNit}</small>
            </div>
            <div className="col-md-6">
                <strong>Valor </strong><small>{(beanUBL.TotalInvoiceAmount)}</small>
            </div>
            <div className="col-md-6">
                <strong>Concepto </strong><small>{beanUBL.AccountantConceptName}</small>
            </div>
            <div className="col-md-6">
                <strong>Proceso </strong><small>{beanUBL.ProcessTypeName}</small>
            </div>
            <div className="col-md-6">
                <strong>ID Factura </strong><small>{beanUBL.IDUBLInvoice}</small>
            </div>
            <div className="col-md-6">
                <strong>Fecha Factura </strong><small>{beanUBL.IssueDate}</small>
            </div>

            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotonesImpuesto()} />
            </div>

            <div className="col-md-12">
                <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                    <TaxHoldValueListByIDUBLTaxWithHoldingTax HoldingTax={bean} />
                </Modal>
                <Modal modal={modalBase.modal} updateModal={modalBase.setModal} eventModal={updateUblTax} onSubmitLabel="Actualizar" >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Base</label>
                            <InputMoney _value={bean.TaxableAmount} onChange={(e)=>{setBean({...bean,TaxableAmount:e})}}/>
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => { parseTaxSchemaValuesWithHoldingTaxForUBLInvoice() }} onSubmitLabel="Agregar Impuestos Seleccionados"  >
                    <div className="row">
                        {pending.length > 0 ?
                            <div className="col-md-12">
                                <Alert clase="primary" >
                                    <strong>Pendientes</strong> Tiene {pending.length} items pendientes por validar la cuenta contable y el centro de costo
                                </Alert>
                                <ul className="list-group">
                                    {pending.map((element: any, index: number) => {
                                        return (
                                            <li className="list-group-item">{element.Description}</li>
                                        )
                                    })}
                                </ul>
                            </div>
                            :
                            <>
                                <div className="col-md-12">
                                    <TaxSchemeSimulator _invoice={beanUBL} menuComponent={false} idAccount={beanUBL.IDAccountSupplier} idUBLInvoice={beanUBL.IDUBLInvoice} issueDate={beanUBL.IssueDate} _onChange={setListTax} />
                                </div>
                            </>
                        }
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { updateUBLTaxWithHoldingTax() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Valor Retención</label>
                            <input type="number" className="form-control" value={bean.TaxAmount} onChange={(e) => { setBean({ ...bean, "TaxAmount": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-1">

                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteTaxSchemeWithHoldingTaxForUBLInvoice}>
                    {/* eliminar impuesto de la factura electronica */}
                    <p>Eliminar impuesto</p>
                </ModalConfirm>
            </div>

        </div>
    )
}